import { motion } from "framer-motion";
import SectionHeading from "@/components/home/SectionHeading";
import { IonIcon } from "@/components/icons/AppIcon";
import { fadeUp } from "@/components/home/motion";

// Delivered in app preview, not yet proven in the store builds: always shown as "Binnenkort"
const UPCOMING = [
  {
    icon: "locate-outline",
    title: "Mijn locatie",
    desc: "Een persoonlijke kaart met je eigen positie. Bewaar je vertrekpunt en vaste plekken, teken of neem een route op en vind de weg terug naar je vertrekpunt. Met weer, wind en snelle acties. De trofeeënkaart blijft apart bereikbaar.",
  },
  {
    icon: "navigate-outline",
    title: "Opgeslagen routes",
    desc: "Al je routes in één lijst. Tik er een aan en zie het hele spoor met begin en eind, de afstand, de datum en de duur. Terugkijken kan zonder dat je locatie aan staat; volgen of opnemen start alleen als jij dat wilt.",
  },
  {
    icon: "people-outline",
    title: "Samen op pad",
    desc: "Deel tijdelijk je live locatie met een jachtmaat, alleen als jullie dat allebei accepteren, en chat één-op-één. Ook zonder gezamenlijk jachtgebied. Uitnodigen gaat via je contacten of een code. Je stopt het delen wanneer je wilt, het loopt vanzelf af en je ziet wanneer de laatste update was.",
  },
  {
    icon: "eye-outline",
    title: "Waarnemingen en wildschade",
    desc: "Leg je eigen waarnemingen en wildschade vast met plek en foto. Jij kiest bewust wat je deelt. In een gekoppeld jachtgebied gelden de bestaande rechten.",
  },
  {
    icon: "grid-outline",
    title: "Kadastrale percelen als grens",
    desc: "Kies in Nederland kadastrale percelen als grens van je jachtgebied, zonder over te tekenen. Aangrenzende percelen vormen samen één buitengrens, losliggende delen blijven apart. Zelf tekenen en aanpassen blijft mogelijk, en hectares tellen bij overlap niet dubbel.",
  },
  {
    icon: "globe-outline",
    title: "Schotland, Engeland en PDF-export",
    desc: "Schotland en Engeland staan apart in de landenkeuze voor trofeeën en jachtgebieden. De PDF van je gebied en kaart werkt ook voor gebieden in het buitenland. Kadastrale gegevens staan er alleen in voor Nederland.",
  },
];

export default function UpcomingSection() {
  return (
    <section id="binnenkort" data-testid="upcoming-section" className="border-t border-[#2C2E29] py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <SectionHeading eyebrow="Nieuw – binnenkort beschikbaar" title="Dit komt eraan in de volgende update.">
          Deze functies zitten in de komende versie van Waidbook en staan nog niet in de App Store en
          Google Play. Zodra de update beschikbaar is, vind je ze in de app.
        </SectionHeading>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {UPCOMING.map((f, i) => (
            <motion.div
              key={f.title}
              data-testid={`upcoming-card-${i}`}
              variants={fadeUp} initial="hidden" whileInView="show"
              viewport={{ once: true, amount: 0.3 }} custom={i}
              className="rounded-2xl border border-[#2C2E29] bg-[#1C1D1A] p-7 transition-colors duration-300 hover:border-[#CAA362]/40"
            >
              <div className="mb-6 flex items-center justify-between gap-3">
                <div className="icon-tile">
                  <IonIcon name={f.icon} />
                </div>
                <span className="rounded-md border border-[#CAA362]/40 px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-[#CAA362]">
                  Binnenkort
                </span>
              </div>
              <h3 className="mb-2 font-serif-display text-xl font-semibold text-[#EAEBE7]">{f.title}</h3>
              <p className="text-sm leading-relaxed text-[#B5B8B0]">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
